export const tramitesyservicios = [
    {
        "tramite_loc" : "Administración de Patrimonio Social",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Apoyo Funcional y Subsidios en Especie a Personas Vulnerables sin Seguridad Social",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1179"
            },
         ]
    },
    {
        "tramite_loc" : "Centro Estatal de Transfusión Sanguínea",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Atención a Solicitudes de Componentes de la Sangre para la Atención de Pacientes",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1167"
            },
            {
                "tramite_item_nombre" : "Atención a Personas que Acuden a Realizar Donación de Sangre",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1171"
            },
         ]
    },
    {
        "tramite_loc" : "Comisión de Arbitraje Médico del Estado de Hidalgo",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Asesoría",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/7265"
            },
            // {
            //     "tramite_item_nombre" : "Dictamen médico - pericial",
            //     "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/7267"
            // },
            {
                "tramite_item_nombre" : "Gestión Inmediata",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/7270"
            },
            {
                "tramite_item_nombre" : "Orientación",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/7272"
            },
            {
                "tramite_item_nombre" : "Queja",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/7273"
            }
         ]
    },
    {
        "tramite_loc" : "Comisión para la Protección Contra Riesgos Sanitarios del Estado de Hidalgo",
        "tramites_array" : [
           {
               "tramite_item_nombre" : "Aviso de Previsiones de Compra Venta de Estupefacientes para Farmacias, Droguerías y Boticas",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1192"
           },
           {
               "tramite_item_nombre" : "Solicitud de Licencia Sanitaria para Farmacias o Boticas con Venta de Medicamentos Controlados",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1193"
           },
           {
               "tramite_item_nombre" : "Permiso de Libros de Control de Estupefacientes y Psicotrópicos",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1203"
           },
           {
               "tramite_item_nombre" : "Certificado de Calidad del Agua de Sistemas Públicos y Privados",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1207"
           },
           {
               "tramite_item_nombre" : "Solicitud de Licencia Sanitaria para Servicios Urbanos de Fumigación y Control de Plagas",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1213"
           },
           {
               "tramite_item_nombre" : "Autorización de Campañas o Jornadas Médicas para Prestación de Servicios de Salud",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1224"
           },
           {
               "tramite_item_nombre" : "Permiso de Publicidad Modalidad A Productos y Servicios",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1496"
           },
           {
               "tramite_item_nombre" : "Solicitud de Visita de Verificación de Medicamentos que Sean o Contengan Estupefacientes Modalidad A. Destrucción",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1499"
           },
           {
               "tramite_item_nombre" : "Solicitud de Visita de Verificación de Materia Prima y Medicamentos que Sean o Contengan Estupefacientes o Psicotrópicos Modalidad A. Balance",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1500"
           },
           {
               "tramite_item_nombre" : "Aviso de Actualización de Datos o Baja del Establecimiento de Insumos para la Salud que Opera con Licencia Sanitaria",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8718"
           },
           {
               "tramite_item_nombre" : "Aviso de Actualización de Datos para Servicios Urbanos de Fumigación y Control de Plagas Urbanas del Establecimiento que Opera con Licencia Sanitaria",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8719"
           },
           {
               "tramite_item_nombre" : "Aviso de Funcionamiento de Crematorio",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8720"
           },
           {
               "tramite_item_nombre" : "Aviso de Funcionamiento de Panteón",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8722"
           },
           {
               "tramite_item_nombre" : "Licencia Sanitaria de Unidades Móviles para Traslado de Cadáveres",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8727"
           },
           {
               "tramite_item_nombre" : "Solicitud de Modificación a la Licencia Sanitaria de Establecimientos de Insumos para la Salud Modalidad G, Farmacia o Botica (con Venta de Medicamentos Controlados)",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8739"
           },
           {
               "tramite_item_nombre" : "Solicitud de Modificación a la Licencia Sanitaria para Servicios Urbanos de Fumigación y Control de Plagas",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8740"
           },
           {
               "tramite_item_nombre" : "Permiso Sanitario para Traslado de Cadáveres o Restos Áridos Fuera del Territorio Estatal",
               "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/8746"
           }
        ]
    },
    {
        "tramite_loc" : "Dirección de Planeación",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Solicitud de Clave Única de Establecimientos de Salud (CLUES)",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/11417"
            },
         ]
    },
    {
        "tramite_loc" : "Laboratorio Estatal de Salud Publica de Hidalgo",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Análisis de Muestras Contra Riesgos Sanitarios en el Laboratorio Estatal de Salud Pública",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1155"
            },
            {
                "tramite_item_nombre" : "Análisis de Muestras Humanas en el Laboratorio Estatal de Salud Pública",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1156"
            },
            {
                "tramite_item_nombre" : "Análisis de Muestras Citológicas en el Laboratorio Estatal de Salud Pública",
                "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1157"
            }
         ]
    },
    // {
    //     "tramite_loc" : "UNEME EC Pachuca",
    //      "tramites_array" : [
    //         {
    //             "tramite_item_nombre" : "Atención Integral a Mayores de 20 años con Enfermedades Crónico-Degenerativas (UNEME EC)",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1181"
    //         }
    //      ]
    // },
    // {
    //     "tramite_loc" : "Subdirección de Apoyo a la Operación",
    //      "tramites_array" : [
    //         {
    //             "tramite_item_nombre" : "Examen de Laboratorio",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1042"
    //         },
    //         {
    //             "tramite_item_nombre" : "Expedición de certificado de defunción",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1043"
    //         }
    //      ]
    // }
    // {
    //     "tramite_loc" : "Centro Estatal de Atención Geriátrica Integral (CESAGI)",
    //      "tramites_array" : [
    //         {
    //             "tramite_item_nombre" : "Atención integral a mayores de 60 años en el Centro Estatal de Atención Geriátrica Integral",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1180"
    //         },
    //      ]
    // },
    // {
    //     "tramite_loc" : "Dirección de Hospitales",
    //      "tramites_array" : [
    //         {
    //             "tramite_item_nombre" : "Servicio medico hospitalario",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1147"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención médica psiquiátrica",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1075"
    //         }
    //      ]
    // },
    // {
    //     "tramite_loc" : "Subdirección de Atención Integral",
    //      "tramites_array" : [
    //         {
    //             "tramite_item_nombre" : "Atención Integral al escolar de 6 a 14 años",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/869"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención Integral al menor de 5 años de edad",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/871"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención Integral al Adolecente de 10 a 19 años",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/874"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención Integral a la mujer de 15 a 59 años de edad",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/878"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención Integral al hombre de 15 a 59 años de edad",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1036"
    //         },
    //         {
    //             "tramite_item_nombre" : "Atención Integral al Adulto Mayor de 60 años",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1039"
    //         },
    //         {
    //             "tramite_item_nombre" : "Certificado Médico",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1041"
    //         },
    //         {
    //             "tramite_item_nombre" : "Salud Mental Comunitaria",
    //             "transparencia_item_url" : "https://ruts.hidalgo.gob.mx/ver/1072"
    //         }
    //      ]
    // },    
]

